import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import api from "../../../api/axiosClient";

const avi = (name) =>
  `https://ui-avatars.com/api/?name=${encodeURIComponent(name || "C")}&background=fff000&color=000000&size=96&bold=true`;

const THREAD_POLL_MS = 4000;
const LIST_POLL_MS = 15000;

const dayKey = (v) => {
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? "" : d.toDateString();
};
const dayLabel = (v) => {
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return "";
  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);
  if (d.toDateString() === today.toDateString()) return "Today";
  if (d.toDateString() === yesterday.toDateString()) return "Yesterday";
  return d.toLocaleDateString("en-KE", { day: "numeric", month: "short", year: "numeric" });
};
const timeLabel = (v) => {
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? "" : d.toLocaleTimeString("en-KE", { hour: "2-digit", minute: "2-digit" });
};

const CSS = `
.msg { --ink:#0c0c0b; --muted:#6b6b66; --line:#e6e6e1; --fill:#f3f3ef; --y:#fff000;
  max-width: 1100px; margin: 0 auto; color: var(--ink); font-family: inherit; font-size: 14px; line-height: 1.5; }
.msg *, .msg *::before, .msg *::after { box-sizing: border-box; }
.msg button, .msg input { font: inherit; }
.msg :focus-visible { outline: 2px solid var(--ink); outline-offset: 2px; }
.msg-scroll { scrollbar-width: thin; scrollbar-color: #d8d8d2 transparent; overscroll-behavior: contain; }

.msg-card { background: #fff; border: 1px solid var(--line); border-radius: 14px; overflow: hidden; }
.msg-shell { display: grid; grid-template-columns: 300px minmax(0, 1fr); height: clamp(480px, calc(100vh - 150px), 740px); }

/* list */
.msg-list { display: flex; flex-direction: column; min-width: 0; min-height: 0; border-right: 1px solid var(--line); }
.msg-list-hd { display: flex; align-items: center; justify-content: space-between; gap: 8px; padding: 16px 18px; border-bottom: 1px solid var(--line); }
.msg-list-hd h2 { margin: 0; font-size: 15px; font-weight: 600; }
.msg-pill { min-width: 24px; padding: 2px 8px; border-radius: 10px; background: var(--y); color: #000; font-size: 12px; font-weight: 700; text-align: center; }
.msg-rows { flex: 1; min-height: 0; overflow-y: auto; }
.msg-row { display: flex; align-items: flex-start; gap: 12px; width: 100%; padding: 14px 18px; border: 0; border-bottom: 1px solid var(--line); background: #fff; color: inherit; text-align: left; cursor: pointer; }
.msg-row:hover { background: #fafaf8; }
.msg-row.on { background: #fffbc7; }
.msg-av { width: 40px; height: 40px; flex: 0 0 40px; border-radius: 50%; object-fit: cover; background: var(--fill); border: 1px solid var(--line); }
.msg-row-body { flex: 1; min-width: 0; }
.msg-row-top { display: flex; align-items: center; justify-content: space-between; gap: 8px; }
.msg-name { overflow: hidden; font-size: 14px; font-weight: 600; text-overflow: ellipsis; white-space: nowrap; }
.msg-row.unread .msg-name { font-weight: 700; }
.msg-svc { display: block; overflow: hidden; margin-top: 1px; color: var(--muted); font-size: 12px; text-overflow: ellipsis; white-space: nowrap; }
.msg-prev { display: block; overflow: hidden; margin-top: 4px; color: var(--muted); font-size: 13px; text-overflow: ellipsis; white-space: nowrap; }
.msg-row.unread .msg-prev { color: var(--ink); font-weight: 500; }
.msg-badge { flex: 0 0 auto; min-width: 20px; padding: 1px 6px; border-radius: 10px; background: var(--y); color: #000; font-size: 12px; font-weight: 700; text-align: center; box-shadow: inset 0 0 0 1px rgba(0,0,0,.15); }

/* thread */
.msg-thread { display: flex; flex-direction: column; min-width: 0; min-height: 0; background: #fff; }
.msg-hd { display: flex; align-items: center; gap: 12px; padding: 12px 20px; border-bottom: 1px solid var(--line); }
.msg-back { display: none; place-items: center; width: 36px; height: 36px; flex: 0 0 36px; border: 1px solid var(--line); border-radius: 8px; background: #fff; color: var(--ink); cursor: pointer; }
.msg-back:hover { background: var(--fill); }
.msg-hd-person { flex: 1; min-width: 0; }
.msg-hd-name { margin: 0; overflow: hidden; font-size: 15px; font-weight: 600; text-overflow: ellipsis; white-space: nowrap; }
.msg-hd-sub { margin: 0; overflow: hidden; color: var(--muted); font-size: 13px; text-overflow: ellipsis; white-space: nowrap; }
.msg-job { min-height: 34px; padding: 0 12px; border: 1px solid var(--line); border-radius: 8px; background: #fff; color: var(--ink); font-size: 13px; font-weight: 600; white-space: nowrap; cursor: pointer; }
.msg-job:hover { background: var(--fill); }

.msg-body { flex: 1; min-height: 0; display: flex; flex-direction: column; gap: 8px; padding: 20px; overflow-y: auto; background: #fafaf8; }
.msg-day { align-self: center; margin: 8px 0; padding: 3px 12px; border-radius: 10px; background: var(--fill); color: var(--muted); font-size: 12px; font-weight: 600; }
.msg-bub { align-self: flex-start; max-width: min(78%, 460px); padding: 9px 13px 6px; border: 1px solid var(--line); border-radius: 14px 14px 14px 4px; background: #fff; overflow-wrap: anywhere; white-space: pre-wrap; }
.msg-bub.mine { align-self: flex-end; border-color: #f0e44a; border-radius: 14px 14px 4px 14px; background: #fff7a8; }
.msg-time { margin-top: 2px; color: var(--muted); font-size: 11px; text-align: right; }

.msg-center { margin: auto; max-width: 300px; padding: 24px; text-align: center; color: var(--muted); }
.msg-center b { display: block; margin-bottom: 4px; color: var(--ink); font-size: 15px; font-weight: 600; }
.msg-ico { display: grid; place-items: center; width: 56px; height: 56px; margin: 0 auto 14px; border: 1px solid var(--line); border-radius: 50%; background: var(--fill); color: var(--ink); font-size: 1.15rem; }
.msg-spin { display: inline-block; width: 26px; height: 26px; border: 3px solid var(--line); border-top-color: var(--ink); border-radius: 50%; animation: msg-spin .7s linear infinite; }
@keyframes msg-spin { to { transform: rotate(360deg); } }

.msg-comp { padding: 12px 16px 14px; border-top: 1px solid var(--line); background: #fff; }
.msg-err { margin: 0 0 8px; color: #a8201a; font-size: 13px; font-weight: 500; }
.msg-form { display: flex; align-items: center; gap: 8px; padding: 4px; border: 2px solid transparent; border-radius: 10px; background: var(--fill); }
.msg-form:focus-within { border-color: var(--ink); background: #fff; }
.msg-input { flex: 1; min-width: 0; height: 40px; padding: 0 10px; border: 0; outline: none; background: transparent; color: var(--ink); font-size: 16px; }
.msg-input::placeholder { color: #8c8c8c; }
.msg-send { display: grid; place-items: center; width: 40px; height: 40px; flex: 0 0 40px; border: 0; border-radius: 8px; background: var(--y); color: #000; cursor: pointer; }
.msg-send:hover:not(:disabled) { background: #ffe600; }
.msg-send:disabled { background: #e9e9e4; color: #9a9a94; cursor: not-allowed; }
.msg-closed { padding: 14px 16px; border-top: 1px solid var(--line); background: var(--fill); color: var(--muted); font-size: 13px; text-align: center; }

.msg-empty { max-width: 460px; margin: 40px auto 0; padding: 48px 24px; text-align: center; background: #fff; border: 1px solid var(--line); border-radius: 14px; }
.msg-empty h3 { margin: 0 0 4px; font-size: 16px; font-weight: 600; }
.msg-empty p { margin: 0 auto 18px; max-width: 340px; color: var(--muted); }
.msg-btn { min-height: 42px; padding: 0 20px; border: 0; border-radius: 8px; background: var(--y); color: #000; font-size: 14px; font-weight: 700; cursor: pointer; }
.msg-btn:hover { background: #ffe600; }

@media (max-width: 760px) {
  .msg-shell { display: block; height: calc(100vh - 190px); min-height: 420px; }
  .msg-list, .msg-thread { height: 100%; }
  .msg-list { border-right: 0; }
  .msg-shell.open .msg-list { display: none; }
  .msg-shell:not(.open) .msg-thread { display: none; }
  .msg-back { display: grid; }
  .msg-hd { padding: 10px 12px; }
  .msg-body { padding: 14px 12px; }
  .msg-bub { max-width: 88%; }
}
@media (prefers-reduced-motion: reduce) { .msg-spin { animation: none; } }
`;

/**
 * Props (all optional)
 * - initialJobId:    open this job's conversation straight away
 * - onUnreadChange:  (total) => void, keeps the sidebar badge in sync
 * - onOpenJob:       (jobId) => void, "View job" opens it in the tracker
 * - onRequest:       () => void, button on the empty state
 */
export default function MessagesTab({ initialJobId = null, onUnreadChange, onOpenJob, onRequest }) {
  const [conversations, setConversations] = useState([]);
  const [convLoading, setConvLoading] = useState(true);
  const [convError, setConvError] = useState("");
  const [activeJobId, setActiveJobId] = useState(null);
  const [messages, setMessages] = useState([]);
  const [threadLoading, setThreadLoading] = useState(false);
  const [draft, setDraft] = useState("");
  const [sending, setSending] = useState(false);
  const [sendError, setSendError] = useState("");

  const activeRef = useRef(null);
  const bodyRef = useRef(null);
  const bottomRef = useRef(null);
  const lastIdRef = useRef(null);
  const markingRef = useRef(false);
  const initialDone = useRef(false);

  /* conversations */
  const fetchConversations = useCallback(async ({ silent = false } = {}) => {
    if (!silent) setConvLoading(true);
    try {
      const { data } = await api.get("/my-conversations/");
      setConversations(Array.isArray(data) ? data : []);
      setConvError("");
    } catch (err) {
      console.error("fetchConversations:", err);
      if (!silent) setConvError("We couldn't load your conversations.");
    } finally {
      if (!silent) setConvLoading(false);
    }
  }, []);

  useEffect(() => { fetchConversations(); }, [fetchConversations]);

  useEffect(() => {
    const timer = setInterval(() => fetchConversations({ silent: true }), LIST_POLL_MS);
    return () => clearInterval(timer);
  }, [fetchConversations]);

  const totalUnread = useMemo(
    () => conversations.reduce((s, c) => s + (Number(c.unread_count) || 0), 0),
    [conversations]
  );
  useEffect(() => { if (onUnreadChange) onUnreadChange(totalUnread); }, [totalUnread, onUnreadChange]);

  /* thread */
  const markRead = useCallback(async (jobId) => {
    if (markingRef.current) return;
    markingRef.current = true;
    try {
      await api.post(`/job-requests/${jobId}/messages/mark-read/`);
      setConversations((prev) =>
        prev.map((c) => (String(c.job_id) === String(jobId) ? { ...c, unread_count: 0 } : c))
      );
    } catch (err) {
      console.error("mark-read:", err); // opening a chat must still work
    } finally {
      markingRef.current = false;
    }
  }, []);

  const fetchThread = useCallback(async (jobId, { silent = false } = {}) => {
    if (!silent) setThreadLoading(true);
    try {
      const { data } = await api.get(`/job-requests/${jobId}/messages/`);
      if (String(activeRef.current) !== String(jobId)) return; // a newer chat was opened
      const list = Array.isArray(data) ? data : [];
      setMessages((prev) =>
        prev.length === list.length && prev[prev.length - 1]?.id === list[list.length - 1]?.id ? prev : list
      );
      if (list.some((m) => !m.is_mine && !m.is_read)) markRead(jobId);
    } catch (err) {
      console.error("fetchThread:", err);
    } finally {
      if (!silent) setThreadLoading(false);
    }
  }, [markRead]);

  const openConversation = useCallback(async (jobId) => {
    activeRef.current = jobId;
    lastIdRef.current = null;
    setActiveJobId(jobId);
    setMessages([]);
    setDraft("");
    setSendError("");
    await fetchThread(jobId);
    markRead(jobId);
  }, [fetchThread, markRead]);

  // open the conversation the page asked for (tracker "Message" button, notification)
  useEffect(() => {
    if (initialDone.current || convLoading || initialJobId == null) return;
    initialDone.current = true;
    if (conversations.some((c) => String(c.job_id) === String(initialJobId))) openConversation(initialJobId);
  }, [initialJobId, convLoading, conversations, openConversation]);

  const closeThread = () => {
    activeRef.current = null;
    setActiveJobId(null);
    setMessages([]);
    setDraft("");
    setSendError("");
  };

  useEffect(() => {
    if (activeJobId == null) return undefined;
    const timer = setInterval(() => fetchThread(activeJobId, { silent: true }), THREAD_POLL_MS);
    return () => clearInterval(timer);
  }, [activeJobId, fetchThread]);

  // scroll only for a new last message, and only if the reader is already near the bottom
  useEffect(() => {
    const last = messages[messages.length - 1];
    if (!last || last.id === lastIdRef.current) return;
    const first = lastIdRef.current === null;
    lastIdRef.current = last.id;
    const el = bodyRef.current;
    const nearBottom = !el || el.scrollHeight - el.scrollTop - el.clientHeight < 160;
    if (first || last.is_mine || nearBottom) {
      bottomRef.current?.scrollIntoView({ behavior: first ? "auto" : "smooth", block: "end" });
    }
  }, [messages]);

  const sendMessage = async (e) => {
    e.preventDefault();
    const text = draft.trim();
    if (!text || activeJobId == null || sending) return;
    const jobId = activeJobId;

    setSending(true);
    setSendError("");
    setDraft("");
    try {
      const { data } = await api.post(`/job-requests/${jobId}/messages/`, { text });
      if (String(activeRef.current) === String(jobId)) {
        setMessages((prev) => (data?.id != null && prev.some((m) => m.id === data.id) ? prev : [...prev, data]));
      }
      setConversations((prev) =>
        prev.map((c) =>
          String(c.job_id) === String(jobId)
            ? { ...c, last_message: text, last_message_at: data?.created_at || new Date().toISOString() }
            : c
        )
      );
    } catch (err) {
      console.error("sendMessage:", err);
      if (String(activeRef.current) === String(jobId)) {
        setDraft(text);
        setSendError("Could not send your message. Please try again.");
      }
    } finally {
      setSending(false);
    }
  };

  const active = conversations.find((c) => String(c.job_id) === String(activeJobId));
  const closed = /cancel/i.test(active?.status || "");

  /* states */
  if (convLoading) {
    return (
      <div className="msg">
        <style>{CSS}</style>
        <div className="msg-card"><div className="msg-center" style={{ padding: 80 }} role="status" aria-label="Loading"><span className="msg-spin" /></div></div>
      </div>
    );
  }

  if (convError) {
    return (
      <div className="msg">
        <style>{CSS}</style>
        <div className="msg-empty" role="alert">
          <div className="msg-ico"><i className="fas fa-triangle-exclamation" aria-hidden="true" /></div>
          <h3>Couldn't load messages</h3>
          <p>{convError}</p>
          <button type="button" className="msg-btn" onClick={() => fetchConversations()}>Try again</button>
        </div>
      </div>
    );
  }

  if (conversations.length === 0) {
    return (
      <div className="msg">
        <style>{CSS}</style>
        <div className="msg-empty">
          <div className="msg-ico"><i className="fas fa-comments" aria-hidden="true" /></div>
          <h3>No conversations yet</h3>
          <p>Once a craftsman is assigned to your job, you can message them here.</p>
          {onRequest && <button type="button" className="msg-btn" onClick={onRequest}>Request a service</button>}
        </div>
      </div>
    );
  }

  let prevDay = "";

  return (
    <div className="msg">
      <style>{CSS}</style>

      <div className="msg-card">
        <div className={`msg-shell${activeJobId != null ? " open" : ""}`}>
          {/* conversation list */}
          <aside className="msg-list" aria-label="Your conversations">
            <div className="msg-list-hd">
              <h2>Messages</h2>
              {totalUnread > 0 && <span className="msg-pill">{totalUnread} new</span>}
            </div>
            <div className="msg-rows msg-scroll">
              {conversations.map((c) => {
                const on = String(c.job_id) === String(activeJobId);
                const unread = Number(c.unread_count) > 0;
                return (
                  <button
                    key={c.job_id}
                    type="button"
                    className={`msg-row${on ? " on" : ""}${unread ? " unread" : ""}`}
                    onClick={() => openConversation(c.job_id)}
                    aria-current={on ? "true" : undefined}
                  >
                    <img className="msg-av" src={avi(c.craftsman_name)} alt="" loading="lazy" />
                    <span className="msg-row-body">
                      <span className="msg-row-top">
                        <span className="msg-name">{c.craftsman_name || "Craftsman"}</span>
                        {unread && <span className="msg-badge" aria-label={`${c.unread_count} unread`}>{c.unread_count}</span>}
                      </span>
                      <span className="msg-svc">{c.service || "Service request"}</span>
                      <span className="msg-prev">{c.last_message || "Start a conversation"}</span>
                    </span>
                  </button>
                );
              })}
            </div>
          </aside>

          {/* chat */}
          <section className="msg-thread" aria-label="Conversation">
            {activeJobId == null ? (
              <div className="msg-center">
                <div className="msg-ico"><i className="fas fa-comments" aria-hidden="true" /></div>
                <b>Pick a conversation</b>
                Choose a craftsman from the list to read and send messages.
              </div>
            ) : (
              <>
                <header className="msg-hd">
                  <button type="button" className="msg-back" onClick={closeThread} aria-label="Back to conversations">
                    <i className="fas fa-arrow-left" aria-hidden="true" />
                  </button>
                  <img className="msg-av" src={avi(active?.craftsman_name)} alt="" />
                  <div className="msg-hd-person">
                    <p className="msg-hd-name">{active?.craftsman_name || "Craftsman"}</p>
                    <p className="msg-hd-sub">{active?.service || "Service"}{active?.status ? ` · ${active.status}` : ""}</p>
                  </div>
                  {onOpenJob && (
                    <button type="button" className="msg-job" onClick={() => onOpenJob(activeJobId)}>View job</button>
                  )}
                </header>

                <div className="msg-body msg-scroll" ref={bodyRef} role="log" aria-live="polite" aria-label="Messages">
                  {threadLoading ? (
                    <div className="msg-center"><span className="msg-spin" /></div>
                  ) : messages.length === 0 ? (
                    <div className="msg-center">
                      <div className="msg-ico"><i className="far fa-comment-dots" aria-hidden="true" /></div>
                      <b>Say hello</b>
                      Send your first message to start the conversation.
                    </div>
                  ) : (
                    messages.map((m) => {
                      const k = dayKey(m.created_at);
                      const divider = k && k !== prevDay ? <div className="msg-day" key={`d-${m.id}`}>{dayLabel(m.created_at)}</div> : null;
                      prevDay = k || prevDay;
                      return (
                        <React.Fragment key={m.id}>
                          {divider}
                          <div className={`msg-bub${m.is_mine ? " mine" : ""}`}>
                            {m.text}
                            <div className="msg-time">{timeLabel(m.created_at)}</div>
                          </div>
                        </React.Fragment>
                      );
                    })
                  )}
                  <div ref={bottomRef} />
                </div>

                {closed ? (
                  <div className="msg-closed">This job was cancelled, so messaging is closed.</div>
                ) : (
                  <div className="msg-comp">
                    {sendError && <p className="msg-err" role="alert">{sendError}</p>}
                    <form className="msg-form" onSubmit={sendMessage}>
                      <input
                        className="msg-input"
                        type="text"
                        placeholder="Write a message"
                        aria-label="Write a message"
                        autoComplete="off"
                        maxLength={2000}
                        value={draft}
                        onChange={(e) => { setDraft(e.target.value); setSendError(""); }}
                        disabled={sending}
                      />
                      <button type="submit" className="msg-send" aria-label="Send message" disabled={sending || !draft.trim()}>
                        <i className={sending ? "fas fa-spinner fa-spin" : "fas fa-paper-plane"} aria-hidden="true" />
                      </button>
                    </form>
                  </div>
                )}
              </>
            )}
          </section>
        </div>
      </div>
    </div>
  );
}
